// extracted by mini-css-extract-plugin
export default {"customEmpty":"customEmpty--PzeZC","resant-empty-description":"resant-empty-description--QLFid"};